import React from "react";
import {
  Box,
  Flex,
  Icon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from "@chakra-ui/react";
import { VeriHeading } from "../../VeriHeading";
import { CheckCircleIcon, CloseIcon } from "../../../../icons";
import { nl2br } from "../../../../utils";
import { NotesPopoverProps } from "./PrincipalOverview.types";

export const NotesPopover: React.FC<NotesPopoverProps> = ({ notes }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <Popover isOpen={isOpen} placement="right">
      <PopoverTrigger>
        <Box onMouseOver={open}>
          <Icon
            ml="50px"
            as={CheckCircleIcon}
            color={"icons.grey"}
            boxSize="24px"
          />
        </Box>
      </PopoverTrigger>
      <PopoverContent
        maxHeight="400px"
        p="16px"
        zIndex={4}
        minWidth={"300px"}
        maxWidth={"500px"}
        borderRadius={4}
        boxShadow="0px 2px 4px rgba(40, 41, 61, 0.04), 0px 8px 16px rgba(96, 97, 112, 0.16)!important"
        borderColor="bg.greyLighter"
        backgroundColor="white"
      >
        <PopoverHeader borderBottomWidth="0px" paddingLeft="0" mb="12px">
          <Flex justifyContent="space-between">
            <Flex alignItems="center">
              <VeriHeading textStyle="h5normal">Notes</VeriHeading>
            </Flex>
            <Icon
              ml="12px"
              as={CloseIcon}
              boxSize="20px"
              onClick={close}
              cursor="pointer"
            />
          </Flex>
        </PopoverHeader>
        <PopoverArrow />
        <PopoverBody p="0px" overflowY="auto">
          <Box>{nl2br(notes || "")}</Box>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
